import styled from "styled-components";

export const StyledSubRegimensWrapper = styled.div`
  margin-left: ${({ theme }) => theme.space.md};
  margin-top: ${({ theme }) => theme.space.sm};
`;
